<div class="clr-row" style="padding: 15px;">
  <div class="clr-col-12">

    <app-netscope-flows-datagrid
      [switchFocus]="switchFocus"
      [temporalParameter]="temporalParameter"
      [exportCsvEnabled]="true"
      [showThreats]="true"
      [flowDetails]="flowDetails">
    </app-netscope-flows-datagrid>
  </div>
</div>
